import axios from "axios";
import { authEndpoint } from "../../../routes/api_endpoints";

const sendCode = (phone) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        `${authEndpoint}/sendVerificationCode`,
        { phone },
        { withCredentials: true }
      )
      .then(() => {
        resolve("success");
      })
      .catch(reject);
  });

export default sendCode;
